import { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import logo from "assets/images/logo150.png";

export default function InstitutionalNavbar({ routes, brand }) {
  const [expanded, setExpanded] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);
  const { pathname } = useLocation();
  const header = useRef(null);
  const toggle = useRef(null);

  useEffect(() => {
    setExpanded(null);
    setMobileOpen(false);
  }, [pathname]);

  useEffect(() => {
    const close = (event) => {
      if (!header.current?.contains(event.target)) {
        setExpanded(null);
        setMobileOpen(false);
      }
    };
    document.addEventListener("pointerdown", close);
    return () => document.removeEventListener("pointerdown", close);
  }, []);

  const renderLink = (item) =>
    item.route ? (
      <Link to={item.route} aria-current={pathname === item.route ? "page" : undefined}>
        {item.name}
      </Link>
    ) : (
      <a href={item.href} target="_blank" rel="noreferrer">
        {item.name}
      </a>
    );

  return (
    <div
      className="school-header"
      ref={header}
      onKeyDown={(event) => {
        if (event.key === "Escape") {
          if (expanded !== null) {
            header.current.querySelector(`[data-disclosure="${expanded}"]`)?.focus();
            setExpanded(null);
          } else {
            setMobileOpen(false);
            toggle.current?.focus();
          }
        }
      }}
      onBlur={(event) => {
        if (!event.currentTarget.contains(event.relatedTarget)) setExpanded(null);
      }}
    >
      <div className="school-header__inner">
        <Link className="school-brand" to="/">
          <img src={logo} width="48" height="58" alt="" />
          <span>{brand}</span>
        </Link>
        <button
          className="school-menu-toggle"
          ref={toggle}
          type="button"
          aria-label={mobileOpen ? "Cerrar menú" : "Abrir menú"}
          aria-expanded={mobileOpen}
          aria-controls="school-navigation"
          onClick={() => {
            setMobileOpen(!mobileOpen);
            setExpanded(null);
          }}
        >
          {mobileOpen ? <CloseIcon /> : <MenuIcon />}
        </button>
        <nav id="school-navigation" aria-label="Principal" className={mobileOpen ? "is-open" : ""}>
          <ul className="school-navigation">
            {routes.map((item, index) => (
              <li key={item.name} className="school-navigation__item">
                {item.collapse ? (
                  <>
                    <button
                      type="button"
                      data-disclosure={index}
                      aria-expanded={expanded === index}
                      aria-controls={`school-subnav-${index}`}
                      className={
                        item.collapse.some((child) => child.route === pathname) ? "is-current" : ""
                      }
                      onClick={() => setExpanded(expanded === index ? null : index)}
                    >
                      {item.name}
                      <ExpandMoreIcon fontSize="small" />
                    </button>
                    <ul
                      id={`school-subnav-${index}`}
                      className="school-subnav"
                      hidden={expanded !== index}
                    >
                      {item.collapse.map((child) => (
                        <li key={child.name}>{renderLink(child)}</li>
                      ))}
                    </ul>
                  </>
                ) : item.route || item.href ? (
                  renderLink(item)
                ) : (
                  <span>{item.name}</span>
                )}
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </div>
  );
}

InstitutionalNavbar.propTypes = {
  routes: PropTypes.array.isRequired,
  brand: PropTypes.string.isRequired,
};
